module.exports = {"id":"206058","name":"Mattia De Sciglio","rating":"77","photo":"./data/images/photos/0/206058.png","club":{"name":"Juventus","logo":"./data/images/clubs/Juventus.png"},"positions":["DD","DG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MattiaDeSciglio0.json
// module id = 2909
// module chunks = 0